import config from '../config/config';
import { KeyValueServiceClient } from '../proto/keyvalue_grpc_web_pb';
import * as messages from '../proto/keyvalue_pb';

class KeyValueClient {
  constructor(host = config.keystore_endpoint, options = {}) {
    this.client = new  KeyValueServiceClient(host, null, {  // add transport
    'content-type': 'application/grpc-web'
  });
    this.apiKey = options.apiKey || '';
    this.cognitoToken = options.cognitoToken || '';
  }

  _getMetadata() {
    const metadata = {};
    if (this.cognitoToken) {
      metadata.authorization = `Bearer ${this.cognitoToken}`;
    } else if (this.apiKey) {
      metadata["x-api-key"] = this.apiKey;
    }
    return metadata;
  }

  _call(methodName, request, timeoutMs = 10000) {
    return new Promise((resolve, reject) => {
      const metadata = this._getMetadata();
      this.client[methodName](request, metadata, (err, response) => {
        if (err) {
          console.error(`gRPC Error [${methodName}]:`, err);
          reject(new Error(`${methodName} failed: ${err.message || err.details}`));
          return;
        }
        // Extract json_response (most responses have it)
        const result = response.getJsonResponse ? response.getJsonResponse() : response;
        resolve(result);
      });
    });
  }

  async get(key, timeoutMs = 8000) {
    const req = new messages.GetRequest();
    req.setKey(key);
    return this._call('getValue', req, timeoutMs);
  }

  async add(key, value, timeoutMs = 10000) {
    const req = new messages.AddRequest();
    req.setKey(key);
    req.setValue(value);
    return this._call('addValue', req, timeoutMs);
  }

  async insert(key, value, timeoutMs = 10000) {
    const req = new messages.InsertRequest();
    req.setKey(key);
    req.setValue(value);
    return this._call('insertValue', req, timeoutMs);
  }

  async update(key, value, timeoutMs = 10000) {
    const req = new messages.UpdateRequest();
    req.setKey(key);
    req.setValue(value);
    return this._call('updateValue', req, timeoutMs);
  }

  async delete(key, timeoutMs = 8000) {
    const req = new messages.DeleteRequest();
    req.setKey(key);
    return this._call('deleteValue', req, timeoutMs);
  }
}

export default KeyValueClient;